import Layout from '@layout/Index'

export const occupation = [
  {
    path: '/users/occupation',
    component: Layout,
    children: [
      {
        path: '',
        redirect: 'table',
      },
      {
        path: 'table',
        component: () => import(/* webpackChunkName: "occupation-table" */ './pages/OccupationTable.vue'),
        meta: {
          title: '自选职业列表',
        },
      },
      {
        path: 'create',
        component: () => import(/* webpackChunkName: "occupation-form" */ './pages/OccupationForm.vue'),
        meta: {
          title: '添加自选职业',
        },
      },
      {
        path: 'update/:id',
        component: () => import(/* webpackChunkName: "occupation-form" */ './pages/OccupationForm.vue'),
        meta: {
          title: '修改自选职业',
        },
      },
      {
        path: 'detail/:id',
        component: () => import(/* webpackChunkName: "occupation-detail" */ './pages/OccupationDetail.vue'),
        meta: {
          title: '自选职业详情',
        },
      },
      {
        path: ':id/users',
        component: () => import(/* webpackChunkName: "occupation-table" */ './pages/OccupationUsersTable.vue'),
        meta: {
          title: '自选职业用户列表',
        },
      },
    ],
  },
]



// WEBPACK FOOTER //
// ./src/views/occupation/occupation.route.js